(function(){
  function initSwiper(container) {
    if (!container || container.swiper) return;

    var panel = container.closest('[role="tabpanel"]') || container.closest('.relative');
    var prevBtn = panel && panel.querySelector('.collection-nav-btn.prev');
    var nextBtn = panel && panel.querySelector('.collection-nav-btn.next');

    var mobileCols = parseInt(container.dataset.columnsMobile || '1', 10);
    var desktopCols = parseInt(container.dataset.columnsDesktop || '4', 10);
    var space = parseInt(container.dataset.spaceBetween || '24', 10);

    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded for featured collections');
      return;
    }

    new Swiper(container, {
      loop: false,
      slidesPerView: mobileCols,
      spaceBetween: space / 2,
      simulateTouch: true,
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        type: 'progressbar',
        clickable: false
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        750: { 
          slidesPerView: Math.max(mobileCols, 2), 
          spaceBetween: space / 2 
        },
        990: { 
          slidesPerView: 3, 
          spaceBetween: space - 4 
        },
        1200: { 
          slidesPerView: desktopCols, 
          spaceBetween: space 
        }
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      on: {
        init: function() {
          this.el.classList.add('swiper-initialized');
        }
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.custom-collection-swiper').forEach(initSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });

  document.addEventListener('click', function(e){
    var tabButton = e.target.closest('[role="tab"]');
    if (tabButton) {
      setTimeout(function(){
        document.querySelectorAll('.custom-collection-swiper').forEach(function(c){
          if (c.swiper && c.swiper.update) c.swiper.update();
        });
      }, 300);
    }
  });
})();